import React from "react";

interface Props {
    settings: any,
    setSettings: any
}
const VehicleOwnerPrices = (props: Props) => {
    const { } = props;
    return(
        <>
            <span>veehicleOwnerPrices</span>
        </>
    );
}

export default VehicleOwnerPrices;